module.exports = __webpack_public_path__ + "img/en.01cd3808.svg";